import { render, staticRenderFns } from "./ApplicantApplicants.vue?vue&type=template&id=1b150b78&scoped=true"
import script from "./ApplicantApplicants.vue?vue&type=script&lang=js"
export * from "./ApplicantApplicants.vue?vue&type=script&lang=js"
import style0 from "./ApplicantApplicants.vue?vue&type=style&index=0&id=1b150b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b150b78",
  null
  
)

export default component.exports